import { Component, Input } from '@angular/core';
import { FileUploadResults } from 'src/app/core/models/file-upload-results.model';
import { FILE_UPLOAD_RESPONSE_CONSTANTS } from './file-upload-results.constants';

@Component({
  selector: 'app-file-upload-results',
  templateUrl: './file-upload-results.component.html',
  styleUrl: './file-upload-results.component.scss',
  standalone: false,
})
export class FileUploadResultsComponent {
  @Input() response!: FileUploadResults;
  @Input() invalidItems!: string | string[];
  CONSTANTS = FILE_UPLOAD_RESPONSE_CONSTANTS;
}
